"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHR = exports.XHRMock = void 0;
const createIXhrResponse = (value, httpStatus, responseHeaders) => {
    return {
        data: value,
        httpStatus,
        httpStatusText: httpStatus >= 200 && httpStatus < 300 ? 'ok' : 'ko',
        ok: httpStatus >= 200 && httpStatus < 300,
        responseHeaders: responseHeaders || {},
    };
};
const resolveXhr = (fn, value, responseHeaders) => {
    return fn.mockResolvedValue(createIXhrResponse(value, 200, responseHeaders));
};
const rejectXhr = (fn, value, httpStatus, responseHeaders) => {
    return fn.mockRejectedValue(createIXhrResponse(value, httpStatus, responseHeaders));
};
class XHRMock {
    constructor() {
        this.GET = jest.fn();
        this.POST = jest.fn();
        this.PUT = jest.fn();
        this.PATCH = jest.fn();
        this.DELETE = jest.fn();
        this.__setGetResolveRequest = (value, responseHeaders) => resolveXhr(this.GET, value, responseHeaders);
        this.__setGetRejectRequest = (value, httpStatus, responseHeaders) => rejectXhr(this.GET, value, httpStatus, responseHeaders);
        this.__setPostResolveRequest = (value, responseHeaders) => resolveXhr(this.POST, value, responseHeaders);
        this.__setPostRejectRequest = (value, httpStatus, responseHeaders) => rejectXhr(this.POST, value, httpStatus, responseHeaders);
        this.__setPutResolveRequest = (value, responseHeaders) => resolveXhr(this.PUT, value, responseHeaders);
        this.__setPutRejectRequest = (value, httpStatus, responseHeaders) => rejectXhr(this.PUT, value, httpStatus, responseHeaders);
        this.__setPatchResolveRequest = (value, responseHeaders) => resolveXhr(this.PATCH, value, responseHeaders);
        this.__setPatchRejectRequest = (value, httpStatus, responseHeaders) => rejectXhr(this.PATCH, value, httpStatus, responseHeaders);
        this.__setDeleteResolveRequest = (value, responseHeaders) => resolveXhr(this.DELETE, value, responseHeaders);
        this.__setDeleteRejectRequest = (value, httpStatus, responseHeaders) => rejectXhr(this.DELETE, value, httpStatus, responseHeaders);
    }
}
exports.XHRMock = XHRMock;
const XHR = XHRMock;
exports.XHR = XHR;
//# sourceMappingURL=xhr.js.map